import type { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from '../helpers/twMerge';
import { Icon } from '@clubmed/trident-icons';
import clsx from 'clsx';

export function FormControlError({
  children,
  className,
  ...args
}: PropsWithChildren<HTMLAttributes<HTMLSpanElement>>) {
  return (
    <span
      {...args}
      data-testid="FormControlError"
      className={clsx('text-red', twMerge('text-b4 flex items-start gap-x-4 px-20', className))}
    >
      <Icon name="Error" width="20px" />
      {children}
    </span>
  );
}
